import { useEffect, useRef, useState } from "react";

const SERVICES = [
  {
    id: "service-3d-print",
    title: "Custom 3D Print & Build",
    desc: "Functional prototyping and batch physical fabrication with industrial tolerances.",
    img: "https://images.unsplash.com/photo-1638959492386-f9a68d55c374?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHwzZCUyMHByaW50ZXIlMjBtZWNoYW5pY2FsJTIwZ2VhcnxlbnwwfHx8fDE3OTI3NDMzNTl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Industrial resin 3D printer extruding precision mechanical gear",
  },
  {
    id: "service-digital-web",
    title: "Digital Brand & Web",
    desc: "High-conversion websites, modern e-commerce architectures, and vector identity systems.",
    img: "https://images.pexels.com/photos/13570173/pexels-photo-13570173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Dark mode digital interface on glass display tablet",
  },
  {
    id: "service-media-launch",
    title: "Turnkey Media & Launch",
    desc: "Tangible merchandise, unboxing experiences, launch video assets, and distribution marketing.",
    img: "https://images.unsplash.com/photo-1760804876422-7efb73b58048?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxibGFjayUyMHByb2R1Y3QlMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzkyNzQzMzU5fDA&ixlib=rb-4.1.0&q=85",
    alt: "Sleek matte black product packaging with embossed metallic foil",
  },
];

function ServiceCard({ service }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setVisible(true),
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      data-testid={service.id}
      className={`reveal ${visible ? "revealed" : ""} border border-[#24283b] bg-[#121624]/60 p-6 flex flex-col justify-between hover:border-[#45f3ff] transition-colors group`}
    >
      <div className="w-full h-44 mb-6 relative overflow-hidden rounded-none">
        <img
          src={service.img}
          alt={service.alt}
          className="absolute inset-0 w-full h-full object-cover img-drift"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[#0b0c10]/20 group-hover:bg-transparent transition-colors"></div>
      </div>
      <div>
        <h3 className="font-display text-2xl uppercase tracking-wide text-white mb-2">
          {service.title}
        </h3>
        <p className="text-neutral-400 text-xs leading-relaxed">{service.desc}</p>
      </div>
    </div>
  );
}

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 px-6 lg:px-12 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
        <div>
          <span className="font-mono-goat text-xs uppercase tracking-widest text-[#45f3ff]">
            One-Stop Full Stack
          </span>
          <h2 className="font-display text-4xl lg:text-5xl uppercase tracking-tight text-white mt-2">
            End-To-End Capabilities
          </h2>
        </div>
        <p className="text-neutral-400 text-sm max-w-md">
          Bridging code and matter for founders, startups, and established enterprises.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s) => (
          <ServiceCard key={s.id} service={s} />
        ))}
      </div>
    </section>
  );
}
